import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const certImages = [
  "https://customer-assets-eiarnc6j.emergentagent.net/job_aesthetic-premium-1/artifacts/56athm5e_5103118861250268184.jpg",
  "https://customer-assets-eiarnc6j.emergentagent.net/job_aesthetic-premium-1/artifacts/gs6u6nmh_5103118861250268185.jpg",
  "https://customer-assets-eiarnc6j.emergentagent.net/job_aesthetic-premium-1/artifacts/gsfdsbbn_5103118861250268186.jpg",
  "https://customer-assets-eiarnc6j.emergentagent.net/job_aesthetic-premium-1/artifacts/di3qw4et_5103118861250268187.jpg",
  "https://customer-assets-eiarnc6j.emergentagent.net/job_aesthetic-premium-1/artifacts/m9hcii3a_5103118861250268188.jpg"
];

export default function CertificatesCarousel() {
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  const total = certImages.length;
  const touchStartX = useRef(null);
  const touchDeltaX = useRef(0);

  useEffect(() => {
    if (paused) return;
    const id = setInterval(() => setIdx((i) => (i + 1) % total), 3000);
    return () => clearInterval(id);
  }, [paused, total]);

  const go = (dir) => setIdx((i) => (i + dir + total) % total);

  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchDeltaX.current = 0;
  };
  const onTouchMove = (e) => {
    if (touchStartX.current == null) return;
    touchDeltaX.current = e.touches[0].clientX - touchStartX.current;
  };
  const onTouchEnd = () => {
    const dx = touchDeltaX.current;
    if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    touchStartX.current = null;
    touchDeltaX.current = 0;
  };

  return (
    <div
      data-testid="certificates-carousel"
      className="relative mx-auto w-full max-w-[720px]"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <div className="relative rounded-[20px] bg-[#F3EFEA] border border-[#E5E0DA] shadow-[0_10px_40px_rgba(0,0,0,0.05)] h-[380px] sm:h-[440px] md:h-[480px] overflow-hidden">
        {certImages.map((src, i) => (
          <img
            key={src}
            src={src}
            alt={`Certificate ${i + 1}`}
            className={`absolute inset-0 w-full h-full object-contain p-6 md:p-10 transition-opacity duration-[900ms] ease-in-out ${i === idx ? "opacity-100" : "opacity-0"}`}
            draggable={false}
          />
        ))}

        <button
          type="button"
          data-testid="cert-prev"
          onClick={() => go(-1)}
          aria-label="Previous certificate"
          className="absolute left-3 md:left-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-11 md:h-11 rounded-full bg-white/85 backdrop-blur border border-[#E5E0DA] flex items-center justify-center hover:bg-white transition-colors"
        >
          <ChevronLeft strokeWidth={1.5} className="w-4 h-4 md:w-5 md:h-5" />
        </button>
        <button
          type="button"
          data-testid="cert-next"
          onClick={() => go(1)}
          aria-label="Next certificate"
          className="absolute right-3 md:right-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-11 md:h-11 rounded-full bg-white/85 backdrop-blur border border-[#E5E0DA] flex items-center justify-center hover:bg-white transition-colors"
        >
          <ChevronRight strokeWidth={1.5} className="w-4 h-4 md:w-5 md:h-5" />
        </button>
      </div>

      <div className="flex items-center justify-center gap-2 mt-6" role="tablist" aria-label="Certificate slides">
        {certImages.map((_, i) => (
          <button
            key={i}
            type="button"
            data-testid={`cert-dot-${i}`}
            onClick={() => setIdx(i)}
            aria-label={`Go to certificate ${i + 1}`}
            className={`h-1.5 rounded-full transition-all duration-300 ${i === idx ? "w-6 bg-[#1A1A1A]" : "w-1.5 bg-[#D8D2CB] hover:bg-[#8A847C]"}`}
          />
        ))}
      </div>
    </div>
  );
}
